import { render, staticRenderFns } from "./transferPayment.vue?vue&type=template&id=df7298a6&scoped=true&"
import script from "./transferPayment.vue?vue&type=script&lang=ts&"
export * from "./transferPayment.vue?vue&type=script&lang=ts&"
import style0 from "./transferPayment.vue?vue&type=style&index=0&id=df7298a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7298a6",
  null
  
)

export default component.exports